<div style="width: 100%;">
  <h2 mat-dialog-title>
    <ng-container *ngIf="!editingTitle; else editMode">
      {{ report.rep_title }}
      <button (click)="toggleEditTitle()" aria-label="Edit title" class="edit-button">
        <mat-icon>edit</mat-icon>
      </button>
    </ng-container>

    <ng-template #editMode>
      <input [(ngModel)]="report.rep_title" (keydown.enter)="toggleEditTitle()" class="mat-dialog-title"
        style="font: inherit; border: none; outline: none; width: auto;" />
      <button (click)="toggleEditTitle()" aria-label="Done editing" class="edit-button">
        <mat-icon>done</mat-icon>
      </button>
    </ng-template>
  </h2>

  <mat-dialog-content class="dialog-content">

    <div class="filter-bar">
      <span class="example-spacer"></span>
      <button mat-icon-button matTooltip="Filters" cdkOverlayOrigin #filterTrigger="cdkOverlayOrigin"
        (click)="filterOpen = !filterOpen">
        <mat-icon>filter_list</mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="xyMenu"
        matTooltip="Chart settings"><mat-icon>settings</mat-icon></button>
    </div>

    <mat-chip-set class="active-filter-chips" *ngIf="activeFilters.length">
      <mat-chip *ngFor="let chip of activeFilters" [removable]="true" (removed)="removeActiveFilterChip(chip)">
        {{ chip.key.display_key ?? chip.key.db_key }}:
        <strong *ngIf="chip.key.filterType !== 'dateRange'">{{ chip.value }}</strong>
        <strong *ngIf="chip.key.filterType === 'dateRange'">
          {{ chip.value.start | date:'dd.MM.yyyy' }} – {{ chip.value.end | date:'dd.MM.yyyy' }}
        </strong>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-set>



    <div class="graph-container">
      <app-reporting-graph [report]="report" (segmentClicked)="onSegmentClicked($event)"></app-reporting-graph>
      <div class="graph-hint">
        Click a bar or slice to view matching tickets
      </div>
    </div>

    <!--div class="selction-wrapper" style="margin-top: 5px;">
      <mat-form-field class="input-formfield">
        <mat-label>Chart Type</mat-label>
        <mat-select (valueChange)="onTypeChange($event)" [(ngModel)]="report.rep_chartType">
          <mat-option value="bar">Bar</mat-option>
          <mat-option value="line">Line</mat-option>
          <mat-option value="pie">Pie</mat-option>
          <mat-option value="doughnut">Doughnut</mat-option>
          <mat-option value="radar">Radar</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-formfield">
        <mat-label>X Axis</mat-label>
        <mat-select (valueChange)="onXAxisChange($event)" [(ngModel)]="report.rep_xAxisOption.key">
          <mat-option *ngFor="let option of xAxisOptions" [value]="option.key">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div-->

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button (click)="cancel()" [disabled]="isSavingChanges">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSavingChanges">Save</button>
  </mat-dialog-actions>
</div>

<!-- FILTER OVERLAY -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="filterTrigger" [cdkConnectedOverlayOpen]="filterOpen"
  [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="filterOpen = false"
  [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 }]">
  <div class="filter-panel">
    <app-p-ticket-filter [filters]="activeFilters" (httpFilterList)="onFilterChange($event)"
      (applied)="filterOpen = false">
    </app-p-ticket-filter>
  </div>
</ng-template>



<mat-menu #xyMenu="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="xAxisMenu">
    x Axis
  </button>
  <button mat-menu-item [matMenuTriggerFor]="chartTypeMenu">
    Chart type
  </button>
</mat-menu>

<mat-menu #xAxisMenu>
  <button mat-menu-item *ngFor="let option of xAxisOptions" (click)="onXAxisChange(option.key)"
    [(ngModel)]="report.rep_xAxisOption.key">{{ option.label }}</button>
</mat-menu>

<mat-menu #chartTypeMenu="matMenu">
  <button  (click)="onTypeChange('bar')" [(ngModel)]="report.rep_chartType" mat-menu-item >Bar</button>
  <button  (click)="onTypeChange('line')" [(ngModel)]="report.rep_chartType" mat-menu-item >Line</button>
  <button  (click)="onTypeChange('pie')" [(ngModel)]="report.rep_chartType" mat-menu-item >Pie</button>
  <button  (click)="onTypeChange('doughnut')" [(ngModel)]="report.rep_chartType" mat-menu-item >Doughnut</button>
  <button  (click)="onTypeChange('radar')" [(ngModel)]="report.rep_chartType" mat-menu-item >Radar</button>
</mat-menu>